import ImportService from './import.service'

export default class TechnicalSaleService {
  constructor(technicalSaleApiHost) {
    this.technicalSaleApiHost = technicalSaleApiHost
  }

  async import(cooperativeId, file) {
    return ImportService.import(
      `${this.technicalSaleApiHost}/backoffice/v1/import/cooperatives/${cooperativeId}/technical-sales`,
      file,
    )
  }
}
